// src/components/AdminProfile.jsx
import React, { useEffect, useState } from 'react';
import AdminNavbar from './AdminNavbar';

const AdminProfile = () => {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem('admin');
    if (stored) {
      setAdmin(JSON.parse(stored));
    }
  }, []);

  if (!admin) return <p className="text-center mt-10 text-gray-500">Loading profile...</p>;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-yellow-100 to-pink-100">
      <AdminNavbar />
      <div className="bg-white shadow-lg rounded-2xl p-8 w-full max-w-md">
        <div className="flex flex-col items-center">
          <img
            src={admin.profileImage.replace(/\\/g, '/')}
            alt="Profile"
            className="w-32 h-32 rounded-full border-4 border-yellow-400 object-cover"
          />
          <h2 className="text-2xl font-bold mt-4 text-yellow-700">{admin.username}</h2>
          <p className="text-lg text-gray-500 mb-6">{admin.email}</p>
        </div>

        {/* <div className="space-y-4">
          <div className="flex justify-between">
            <span className="font-semibold text-gray-700">Company:</span>
            <span className="text-gray-600">{admin.company || 'N/A'}</span>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default AdminProfile;
